export default __webpack_public_path__ + "static/media/bonus data.709daa5c.png";